import React from 'react';
import { ListWrapper } from '@builtbypixel/nucleus';
import { Button } from '@builtbypixel/plasma';

import setup from './setup';

// Extra Menu appears next to the create button
const extraMenu = () => {
    return null;
};

const List = () => {
    const columns = [
        {
            Header: 'Mosque Name',
            accessor: 'mosque.name',
        },
        {
            Header: 'Month / Year',
            accessor: 'month',
            Cell: ({ row }) => `${row.original.month} - ${row.original.year}`,
        },
        {
            Header: '',
            accessor: 'id',
            Cell: ({ row }) => (
                <a
                    href={`${process.env.REACT_APP_FRONTEND_URL}/account/timetables/preview/${row.original.id}`}
                    target='_blank'
                >
                    <Button variantColor='primary' variant='outline'>
                        View Timetable
                    </Button>
                </a>
            ),
        },
    ];

    return (
        <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />
    );
};

export default List;
